import React from 'react';
import {useOktaAuth} from "@okta/okta-react";
import {Redirect} from "react-router-dom";

const OktaLoginRedirect = () => {
	const oktaAuth = useOktaAuth();

	if(oktaAuth.authState?.isAuthenticated) {
		return <Redirect to={{ pathname: '/profile' }}/>;
	}

	if(!oktaAuth.authState?.isPending) {
		oktaAuth.oktaAuth.token.getWithRedirect();
	}

	return (
		<></>
	);
};

export default OktaLoginRedirect;
